/* Mint-TMS · Điều độ hôm nay (desktop 1536). Số đo theo board; màu chỉ var(--…). */
.page { display: flex; flex-direction: column; gap: 14px; padding: 0 0 32px; min-width: 0; }
.tabs { align-self: flex-start; max-width: 100%; overflow-x: auto; scrollbar-width: none; }
.duty { display: inline-flex; align-items: center; gap: 6px; height: 28px; padding: 0 10px; border-radius: 999px; background: var(--pri-bg); color: var(--link); font-size: 12px; font-weight: var(--fw-label); white-space: nowrap; }
.dot { width: 7px; height: 7px; border-radius: 50%; background: var(--ok-dot); }
.p0 { display: flex; align-items: center; gap: 14px; padding: 12px 12px 12px 16px; border-radius: 14px; background: var(--err-bg); box-shadow: inset 0 0 0 1px var(--err-bd); }
.p0Badge { width: 34px; height: 34px; flex-shrink: 0; border-radius: 10px; background: var(--err); color: var(--on-color); display: flex; align-items: center; justify-content: center; font-weight: 800; }
.p0Tx { flex-grow: 1; min-width: 0; }
.p0Tx b { font-weight: var(--fw-label); }
.sub { font-size: 12px; color: var(--tx2); }
.p0Esc { font-size: 12px; color: var(--err); font-weight: var(--fw-label); white-space: nowrap; }
.kpis { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 14px; }
.kpi { text-align: left; padding: 16px 18px; border: 0; border-radius: 16px; background: var(--card); box-shadow: var(--sh); font: inherit; color: inherit; cursor: pointer; }
.kpi:focus-visible, .leg:focus-visible, .more:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; }
.kpiOn { box-shadow: 0 0 0 2px var(--pri), var(--sh); }
.kpiL { color: var(--lb); display: flex; align-items: center; gap: 6px; }
.kpiV { margin-top: 4px; display: flex; align-items: baseline; gap: 8px; }
.kpiV b { font-size: 30px; font-weight: var(--fw-label); letter-spacing: -0.03em; }
.kpiV span { font-size: 12px; color: var(--lb); }
.toneErr { color: var(--err); }
.toneWarn { color: var(--warn); }
.charts { display: grid; grid-template-columns: minmax(0, 1.6fr) minmax(0, 1.1fr) minmax(0, 0.9fr); gap: 14px; }
.card { padding: 14px 18px; border-radius: 16px; background: var(--card); box-shadow: var(--sh); min-width: 0; }
.h2 { margin: 0; font-size: 16px; font-weight: var(--fw-title); }
.cardHd { display: flex; justify-content: space-between; align-items: baseline; gap: 8px; }
.legend { display: flex; gap: 12px; font-size: 12px; color: var(--lb); }
.legend span { display: inline-flex; align-items: center; gap: 5px; }
.lgLine { width: 14px; height: 3px; border-radius: 2px; background: var(--d-blue); }
.lgDash { width: 14px; height: 0; border-top: 2px dashed var(--d-amber); }
.chart { display: block; height: 118px; margin-top: 6px; overflow: visible; }
.axis { stroke: var(--bd); }
.grid { stroke: var(--line); stroke-dasharray: 3 4; }
.tick { font-size: 11px; fill: var(--lb); font-family: inherit; }
.val { font-size: 11px; font-weight: var(--fw-label); fill: var(--tx); font-family: inherit; }
.note { font-size: 12px; color: var(--lb); }
.donut { display: flex; align-items: center; gap: 14px; margin-top: 8px; }
.donut svg { flex-shrink: 0; }
.legs { flex-grow: 1; min-width: 0; display: flex; flex-direction: column; }
.leg { display: flex; align-items: center; gap: 8px; height: 26px; padding: 0; border: 0; background: transparent; font: inherit; font-size: 12px; color: var(--tx); cursor: pointer; text-align: left; white-space: nowrap; }
.legDot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.legK { flex-grow: 1; }
.legN { font-weight: var(--fw-label); }
.semi { display: block; margin: 8px auto 0; }
.center { text-align: center; }
.main { display: flex; gap: 14px; align-items: flex-start; }
.table { flex: 1 1 0; min-width: 0; border-radius: 16px; background: var(--card); box-shadow: var(--sh); overflow: clip; }
.tHd { display: flex; align-items: center; gap: 10px; padding: 14px 18px 8px; }
.tFilter { margin-left: auto; display: flex; padding: 3px; border-radius: 10px; background: var(--ctl); }
.tf { height: 28px; padding: 0 10px; border: 0; border-radius: 8px; background: transparent; color: var(--tx2); font: inherit; font-size: 12px; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.tf[aria-pressed='true'] { background: var(--ctl-on); color: var(--tx); box-shadow: var(--seg-sh); }
.tf:focus-visible { outline: 2px solid var(--pri); outline-offset: 1px; }
.tBar { display: flex; align-items: center; gap: 8px; padding: 0 18px 10px; }
.search { display: flex; align-items: center; gap: 8px; flex: 1 1 auto; min-width: 0; height: 36px; padding: 0 12px; box-sizing: border-box; border-radius: 10px; background: var(--sub); color: var(--lb); }
.search input { flex-grow: 1; min-width: 0; border: 0; outline: 0; background: transparent; font: inherit; color: var(--tx); }
.tbl { width: 100%; table-layout: fixed; border-collapse: collapse; white-space: nowrap; }
.tbl th { box-sizing: content-box; position: sticky; top: var(--page-head-h, 0px); z-index: 1; background: var(--card); height: 40px; padding: 0 12px; font-size: 12px; font-weight: 500; color: var(--lb); border-bottom: 1px solid var(--line); text-align: left; }
.tbl th:first-child, .tbl td:first-child { padding: 0 0 0 18px; }
.tbl td { box-sizing: content-box; height: 49px; padding: 0 12px; border-bottom: 1px solid var(--line); }
.tbl td:last-child, .tbl th:last-child { padding: 0 12px 0 0; text-align: right; }
.tbl td:nth-child(-n+3) { overflow: hidden; text-overflow: ellipsis; }
.tbl tr[data-row] { cursor: pointer; }
@media (hover: hover) { .tbl tr[data-row]:hover { background: var(--sub); } }
.truck { font-weight: var(--fw-label); }
.s2 { font-size: 12px; color: var(--lb); overflow: hidden; text-overflow: ellipsis; }
.id { font-weight: var(--fw-label); color: var(--link); }
.flag { margin-left: 6px; padding: 1px 6px; border-radius: 999px; font-size: 12px; font-weight: var(--fw-label); background: var(--warn-bg); color: var(--warn); }
.flagErr { background: var(--err-bg); color: var(--err); }
.flagInfo { background: var(--pri-bg); color: var(--link); }
.steps { display: flex; gap: 3px; height: 8px; }
.steps i { flex: 1 1 0; border-radius: 3px; background: var(--line); }
.stDone { background: var(--d-blue) !important; }
.stBad { background: var(--err) !important; }
.stOk { background: var(--d-green) !important; }
.stLate { background: var(--d-amber) !important; }
.stRun { background: color-mix(in srgb, var(--d-blue) 55%, var(--card)) !important; }
.stTx { margin-top: 5px; font-size: 12px; color: var(--lb); overflow: hidden; text-overflow: ellipsis; }
.stTxErr { color: var(--err); }
.stTxWarn { color: var(--warn); }
.dueHot { color: var(--err); font-weight: 600; }
.disp { color: var(--tx2); }
.more { width: 30px; height: 30px; border: 0; border-radius: 8px; background: transparent; color: var(--lb); cursor: pointer; display: inline-flex; align-items: center; justify-content: center; }
.none { padding: 24px 18px; text-align: center; color: var(--lb); }
.foot { height: 42px; display: flex; align-items: center; padding: 0 18px; color: var(--lb); font-size: 12px; }
.side { width: 360px; flex-shrink: 0; display: flex; flex-direction: column; gap: 14px; }
.mapCard { padding: 14px; }
.map { position: relative; height: 250px; border-radius: 12px; background: var(--sub); overflow: hidden; }
.map svg { position: absolute; inset: 0; }
.road { fill: none; stroke: var(--bd); stroke-linecap: round; }
.pin { position: absolute; width: 12px; height: 12px; border-radius: 50%; box-shadow: 0 0 0 3px var(--card); }
.mapLb { position: absolute; left: 10px; bottom: 8px; font-size: 11px; color: var(--lb); }
.un { padding: 14px 16px; }
.unN { font-size: 12px; color: var(--err); font-weight: var(--fw-label); }
.unRow { display: flex; align-items: center; gap: 10px; padding: 10px 0; border-top: 1px solid var(--line); }
.unRow:first-of-type { border-top: 0; }
.unTx { flex-grow: 1; min-width: 0; }
.unTx b { font-weight: var(--fw-label); }
.urg { margin-left: 6px; font-size: 11px; font-weight: var(--fw-label); color: var(--err); }
.unTx .s2 { white-space: nowrap; }
.skel { border-radius: 16px; background: var(--card); box-shadow: var(--sh); }
.skelCards { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 14px; }
@media (max-width: 1279px) {
  .charts { grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); }
  .charts > :first-child { grid-column: 1 / -1; }
  .main { flex-direction: column; align-items: stretch; }
  .side { width: auto; flex-direction: row; }
  .side > * { flex: 1 1 0; min-width: 0; }
}
@media (max-width: 767px) {
  .kpis, .skelCards { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .charts { grid-template-columns: minmax(0, 1fr); }
  .side { flex-direction: column; }
  .p0 { flex-wrap: wrap; }
  .tbl { table-layout: auto; }
  .table { overflow-x: auto; }
  .tBar { flex-wrap: wrap; }
}
@media (pointer: coarse) { .more { width: 44px; height: 44px; } .leg { height: 36px; } }

.fbtn { height: 36px; border-radius: 10px; }

.p0Dock { display: flex; flex-direction: column; gap: 6px; padding: 10px 12px; border-radius: 12px; background: var(--err-bg); box-shadow: inset 0 0 0 1px var(--err-bd); }
.p0DockHd { display: flex; align-items: center; gap: 8px; }
.p0DockHd .p0Esc { margin-left: auto; }
.dkRow { display: flex; gap: 10px; padding: 10px; border-radius: 12px; background: var(--sub); }
.dkDot { width: 8px; height: 8px; margin-top: 6px; flex-shrink: 0; border-radius: 50%; }
.dkTx { min-width: 0; flex-grow: 1; }
.dkAct { align-self: center; height: 30px; padding: 0 10px; border: 0; border-radius: 8px; background: var(--pri-bg); color: var(--link); font: inherit; font-size: 12px; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.dkActErr { background: var(--err); color: var(--btn-tx); }

.p0DockBadge { padding: 2px 7px; border-radius: 7px; background: var(--err); color: var(--on-color); font-size: 12px; font-weight: var(--fw-title); }
.p0DockBtn { height: 32px; font-size: 13px; }
@media (min-width: 1800px) { .page { margin-right: -12px; padding-top: 2px; } .tHd { padding-bottom: 10px; } .tbl td { height: 48px; } } /* board 1920: khối nội dung 1264 = lề trái 24, lề phải 12 trước bảng phải 372 */
